// ABOUTME: Progress bar of the scan or apply job of a run, with the job's progress message and percentage.
// ABOUTME: Indeterminate while the job is queued or has not reported any progress yet.

import { Stack, Typography } from '@ds/coolshop';
import LinearProgress from '@mui/material/LinearProgress';

import { RunJobDto } from '../types';

export function JobProgress({ job }: { job: RunJobDto | null }) {
    const progress = job ? Math.min(Math.max(job.progress, 0), 100) : 0;
    const determinate = !!job && progress > 0;

    return (
        <Stack gap={0.5} data-testid="find-replace-job-progress">
            {determinate ? (
                <LinearProgress variant="determinate" value={progress} />
            ) : (
                <LinearProgress />
            )}
            {(job?.progressMessage || determinate) && (
                <Typography variant="caption" color="textSecondary">
                    {[job?.progressMessage, determinate ? `${Math.round(progress)}%` : null]
                        .filter(Boolean)
                        .join(' · ')}
                </Typography>
            )}
        </Stack>
    );
}
